/* eslint-disable linebreak-style */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import styled from '@react-pdf/styled-components';
import { t } from '../../../../i18n';


// Create styles
const styles = StyleSheet.create({
  section: {
    marginLeft: 25,
    marginTop:5,
    marginBottom:5
  },
  row: {
    display: 'flex',
    flexDirection:'row',
    marginTop:0,
    marginBottom:0,
    marginLeft: 5,
    marginRight: 5,
  },
});

const CellNrCrt = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:3%;
  text-align: center; 
`;
const CellTipSubprodus = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:12%;
  text-align: center;
`;

const CellCulori = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:8%;
  text-align: center;
`;
const CellDimensiuni = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:7%;
  text-align: center;
`;

const CellTipActionare = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:7%;
  text-align: center;
`;

const CellOptional = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:12%;
  text-align: center;
`;
const CellCantitate = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:6%;
  text-align: center;
`;
const CellPret = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:9%;
  text-align: center;
`;
const CellObservatii = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:17%;
  text-align: center;
`;
const CellTotal = styled.Text`
  padding:15px;
  font-size: 15px;
  margin-left:-1px;
  margin-top:-1px;
  text-align: right;
  width:100%;
`;
// Create Document Component
const ContentPI = (props) => {
  return(<View style={styles.section}>
    <View style={styles.row}>
      <CellNrCrt fixed>{t('pdf.content.nrCrt')}</CellNrCrt>
      <CellTipSubprodus fixed>{t('pdf.content.tipRulou')}</CellTipSubprodus>
      <CellCulori fixed>{t('pdf.content.culoare')}</CellCulori>
      <CellDimensiuni fixed>{t('pdf.content.lungime')}</CellDimensiuni>
      <CellDimensiuni fixed>{t('pdf.content.inaltime')}</CellDimensiuni>
      <CellTipActionare fixed>{t('pdf.content.cota')}</CellTipActionare>
      <CellOptional fixed>{t('pdf.content.optional1')}</CellOptional>
      <CellOptional fixed>{t('pdf.content.optional2')}</CellOptional>
      <CellObservatii>{t('pdf.content.observatii')}</CellObservatii>
      <CellCantitate fixed>{t('pdf.content.cant')}</CellCantitate>
      <CellPret fixed>{t('pdf.content.pretEuro')}</CellPret>
      
    </View>
    {props.currentOrder.comandarepers?
      props.currentOrder.comandarepers.sort((a, b) => {
        return new Date(a.actionare) - new Date(b.actionare)}).map(item=>
        <View style={styles.row} key={item.id}>
          <CellNrCrt fixed>{item.nrCrt}</CellNrCrt>
          <CellTipSubprodus fixed>{item.denumireSubProdus}</CellTipSubprodus>
          <CellCulori fixed>{item.denumireCuloareCaseta}</CellCulori>
          <CellDimensiuni fixed>{item.lungime}</CellDimensiuni>
          <CellDimensiuni fixed>{item.inaltime}</CellDimensiuni>
          <CellTipActionare fixed>{item.denumireTipActionare}</CellTipActionare>
          <CellOptional fixed>{item.denumireOptional1}</CellOptional>
          <CellOptional fixed>{item.denumireOptional2}</CellOptional>
          <CellObservatii>{item.observatii}</CellObservatii>
          <CellCantitate fixed>{item.buc}</CellCantitate>
          <CellPret fixed>{item.pretClientFinal}</CellPret>
        </View>
      )
      :<Text>{t('pdf.common.noRows')}</Text>
    }
    <View style={styles.column}>
      <CellTotal fixed>{t('pdf.common.total', { value: props.currentOrder.valoareClientFinal, currency: 'Euro' })}</CellTotal>
      {/* <CellTotalLei fixed>{`Total in Lei la cursul BNR+1% din ${today} (1 Euro = ${cursBnrPlusOnePercent.toFixed(4)}) : ${valoareLei} Lei`}</CellTotalLei> */}
      {/* <CellTotalLei fixed>{`Atentie! Valoare in lei se va recalcula la data facturarii, in functie de cursul valutar valabil la data respectiva.`}</CellTotalLei> */}
    </View>
  </View>
  )};

export default ContentPI